module.exports = __webpack_public_path__ + "img/transfert.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/transfert.png
// module id = 378
// module chunks = 0